import * as facebook from './facebook/reducer'
import * as me from './me/reducer'
import * as cart from './cart/reducer'
import * as modals from './modals/reducer'
import * as review from './review/reducer'
import * as reviews from './reviews/reducer'
import * as products from './products/reducer'
import * as ratedFragrances from './ratedFragrances/reducer'
import * as recommendations from './recommendations/reducer'
import * as payment from './payment/reducer'
import * as requestTokens from './requestTokens/reducer'
import * as queue from './queue/reducer'
import * as subscription from './subscription/reducer'
import * as tours from './tours/reducer'
import * as search from './search/reducer'
import * as giftSet from './giftSet/reducer'
import * as upgradeSubscriptionFlow from './upgradeSubscriptionFlow/reducer'
import * as ui from './ui/reducer'
import * as google from './google/reducer'
import * as seo from './seo/reducer'
import * as collections from './collections/reducer'
import * as breadcrumbs from './breadcrumbs/reducer'
import * as stories from './stories/reducer'
import * as user from './user/reducer'
import * as navigation from './navigation/reducer'
import * as productSets from './productSets/reducer'



// Leave in alphabet order!!!

export default {
  breadcrumbs,
  cart,
  collections,
  facebook,
  giftSet,
  google,
  me,
  modals,
  navigation,
  payment,
  products,
  productSets,
  queue,
  ratedFragrances,
  recommendations,
  requestTokens,
  review,
  reviews,
  search,
  seo,
  stories,
  subscription,
  tours,
  ui,
  upgradeSubscriptionFlow,
  user,
}
